import { z } from "zod";
import { TermSchema } from "./Term";

export const TermRequestSchema = TermSchema.pick({
    terms: true,
});

export type TermRequest = z.infer<typeof TermRequestSchema>;
